/**
 * @file ContactRequestFormModal.tsx
 *
 * Renders the contact request form modal. This displays the form for sending a
 * new contact request to an applicant.
 */
import React from 'react';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { ContactRequestForm } from '~/jobiqo/components/Resume/ContactRequest/Form';
import { Resume } from '~/jobiqo/types/types';

interface ContactRequestFormModalProps {
  /**
   * The resume.
   */
  resume: Resume;
  /**
   * Determines if the form is submitting.
   */
  isSubmitting: boolean;
  /**
   * Function to call when the form is completed.
   */
  onComplete: (event: React.FormEvent<HTMLFormElement>) => void;
  /**
   * The error list component.
   */
  ErrorList: React.ReactNode;
}

export const ContactRequestFormModal = ({
  resume,
  isSubmitting,
  onComplete,
  ErrorList,
}: ContactRequestFormModalProps) => (
  <>
    {ErrorList && (
      <>
        {ErrorList}
        <Spacing />
      </>
    )}
    <ContactRequestForm
      resume={resume}
      isSubmitting={isSubmitting}
      onComplete={onComplete}
      ErrorList={ErrorList}
    />
  </>
);

export default ContactRequestFormModal;
